<div class="card height-100 custom-color p-shadow-9">
    <div class="card-header">
        <h5>Број скидања апликације по месецу</h5>
    </div>

    <p-chart #bar [data]="monthlyChartData" [options]="barChartOptions" [responsive]="true" type="bar" height="400px"></p-chart>
</div>
